import {MenuOption} from "../../MenuKMQ";
import './menu-element.scss';
import {useEffect, useState} from "react";
import SelectIconUp from "../../../../../assets/icons/UI/select/arrow-up.svg";
import SelectIconDown from "../../../../../assets/icons/UI/select/arrow-down.svg";
import {useLocation, useNavigate, useParams} from "react-router-dom";

interface MenuElementProps {
  element: MenuOption,
  index: number
}

const MenuElementKMQ = (props: MenuElementProps) => {
  const {
    element,
    index
  } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const {portfolio_id} = useParams();
  const [optionsAreOpen, setOptionsAreOpen] = useState<boolean>(false);

  useEffect(() => {
    if (portfolio_id) {
      setOptionsAreOpen(true);
    }
  }, [portfolio_id])

  return <div className={`menu-element ${element.active ? 'menu-element-active' : ''}`}
              key={index}
              onClick={element.onClick ? element.onClick : () => setOptionsAreOpen(!optionsAreOpen)}
  >
    {element.icon}
    <span className={`menu-element-text ${element.options ? 'menu-element-text-dropdown' : ''}`}>
      {element.name}
      {
        element.options
          ? <img
            src={optionsAreOpen ? SelectIconUp : SelectIconDown}
            alt={'open-options'}
            className={'menu-element-text-icon'}
          />
          : null
      }
    </span>

    {
      (optionsAreOpen && element.options)
        ? <div className={'menu-element-options'}>
          {element.options.map((item: any, key: number) =>
            <MenuElementKMQ
              element={{
                ...item,
                active: location.pathname.includes(item.link),
                onClick: () => navigate(item.link)
              }}
              index={key}
            />
          )}
        </div> :
        null
    }
  </div>
}

export default MenuElementKMQ;